var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPath = function SvgPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.681 1.427v-.68H7.74v5.968h5.94v-5.29Zm-6 5.355V.68h6.058v6.102H7.68Zm6 8.914v-.68H7.74v5.967h5.94v-5.286Zm-6 5.355v-6.102h6.058v6.102H7.68Zm20.215-5.355v-.68h-5.971v5.967h5.971v-5.286Zm-6.029 5.355v-6.102h6.059v6.102h-6.059Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.717 7.463v6.834",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.896 29.964v-.68h-5.971v5.97h5.971v-5.29Zm-6.029 5.356v-6.102h6.059v6.102h-6.059Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.372 21.76v6.835m-4.157-10.56h-6.796",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
export default SvgPath;